// extracted by mini-css-extract-plugin
export var header = "index-module--header--S31OR";
export var homeLink = "index-module--homeLink--26f3x";
export var burgerIconContainer = "index-module--burgerIconContainer--1Ykz5";
export var burgerIcon = "index-module--burgerIcon--1_GDC";
export var exitContainer = "index-module--exitContainer--JZdzx";
export var exit = "index-module--exit--1gS-E";